import { Card, CardContent, ListItem, Typography } from '@mui/material';
import type React from 'react';
import useCollectionItemsStyles from 'src/CollectionsPage/CollectionItems/CollectionItemView/CollectionItemsStyles';
import CollectionListItem from './CollectionItemCard/CollectionItem';

interface ContentObject {
  id: string;
}

interface CollectionItem {
  contentObject: ContentObject;
}

interface CollectionItemsListProps {
  name: string;
  items: CollectionItem[];
  itemClickCallback: (id: string) => void;
  handleScrollToBottom: () => void;
  selectedItemId: string;
  shared: boolean;
}

const CollectionItemsList: React.FC<CollectionItemsListProps> = ({
  name,
  items,
  itemClickCallback,
  handleScrollToBottom,
  selectedItemId,
  shared,
}) => {
  const setSelectedItemWCallback = (id: string): void => {
    itemClickCallback(id);
  };
  const classes = useCollectionItemsStyles();

  const handleScroll = (e: React.UIEvent<HTMLDivElement>): void => {
    const target = e.target as HTMLElement;
    // thanks to : https://stackoverflow.com/questions/45585542/detecting-when-user-scrolls-to-bottom-of-div-with-react-js
    const bottomAlg = Math.abs(target.scrollHeight - (target.scrollTop + target.clientHeight));
    if (bottomAlg) {
      handleScrollToBottom();
    }
  };

  return (
    <Card onScroll={handleScroll} classes={{ root: classes.card }}>
      <CardContent className={classes.cardHeader}>
        <div className={classes.cardTitle}>
          <Typography variant="h2">{name}</Typography>
        </div>
        <Typography>
          {items.length} item{items.length === 1 ? '' : 's'}
        </Typography>
      </CardContent>
      <CardContent classes={{ root: classes.cardItems }}>
        {items.map((item) => (
          <ListItem
            button
            key={item?.contentObject?.id}
            className={item?.contentObject?.id === selectedItemId ? classes.selected : ''}
            onClick={() => {
              setSelectedItemWCallback(item?.contentObject?.id);
            }}
          >
            <CollectionListItem id={item?.contentObject?.id} shared={shared} />
          </ListItem>
        ))}
      </CardContent>
    </Card>
  );
};

export type { CollectionItem, CollectionItemsListProps };
export default CollectionItemsList;
